import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const sections = [
  {
    title: "1. Aceptación de términos",
    body: [
      "Al acceder o usar Metal Concrete, aceptas estos términos y condiciones. Si no estás de acuerdo, debes abstenerte de usar la plataforma.",
      "Metal Concrete es operada por SUIVOS, S.A. de C.V. (en adelante, SUIVOS).",
      "Estos términos aplican a usuarios, propietarios, brokers, desarrolladoras y cualquier tercero que interactúe con la plataforma.",
    ],
  },
  {
    title: "2. Capacidad y registro",
    body: [
      "Declara que los datos proporcionados en tu registro son veraces, completos y actualizados.",
      "Eres responsable de custodiar tus credenciales y de toda actividad realizada desde tu cuenta.",
      "SUIVOS puede suspender cuentas con indicios de uso indebido, fraude, suplantación o incumplimiento de estos términos.",
    ],
  },
  {
    title: "3. Uso permitido de la plataforma",
    body: [
      "Metal Concrete es una plataforma tecnológica para promoción y gestión inmobiliaria.",
      "La plataforma incluye funcionalidades de co-listing, inventario colaborativo y Solicitudes de Búsqueda. Las Solicitudes de Búsqueda permiten publicar una necesidad inmobiliaria no disponible en el marketplace para que otros usuarios respondan con propuestas de su inventario.",
      "No está permitido publicar información falsa, infringir derechos de terceros, usar la plataforma para actividades ilícitas o enviar contenido malicioso/spam.",
      "SUIVOS puede retirar publicaciones o restringir funcionalidades cuando existan riesgos legales, operativos o de seguridad.",
    ],
  },
  {
    title: "4. Planes, pagos y suscripciones",
    body: [
      "Los pagos se procesan mediante proveedores externos, incluyendo Stripe. Al contratar un plan, autorizas los cargos correspondientes y renovaciones según el plan activo.",
      "Las pruebas gratuitas, promociones o períodos de gracia se otorgan conforme a la política comercial vigente y pueden modificarse o terminarse conforme a ley.",
      "La prueba gratuita de 14 días aplica una sola vez por cuenta elegible. Una vez utilizada, no puede volver a activarse, incluso si la suscripción se cancela o queda inactiva por falta de pago.",
      "Al cancelar, las funciones premium se desactivan conforme al ciclo vigente. La cancelación no elimina automáticamente tu información histórica.",
    ],
  },
  {
    title: "5. Operación comercial y comisiones",
    body: [
      "La plataforma facilita colaboración entre usuarios, incluyendo co-listing, inventario colaborativo, seguimiento operativo y Solicitudes de Búsqueda. A través de las Solicitudes de Búsqueda, los datos de contacto del publicante pueden compartirse con usuarios que respondan, conforme al Aviso de Privacidad vigente.",
      "Los acuerdos económicos, comisiones, obligaciones fiscales y contractuales entre usuarios son responsabilidad exclusiva de las partes involucradas.",
      "SUIVOS no sustituye asesoría legal, fiscal o notarial en operaciones inmobiliarias.",
    ],
  },
  {
    title: "6. Propiedad intelectual y licencias",
    body: [
      "El contenido que publicas sigue siendo tuyo o de su titular legítimo. Al publicarlo, otorgas a SUIVOS una licencia no exclusiva para alojar, mostrar y distribuir dicho contenido dentro de la plataforma para fines operativos y comerciales.",
      "No puedes usar marcas, logotipos, código o contenido protegido de SUIVOS sin autorización previa y por escrito.",
    ],
  },
  {
    title: "7. Limitación de responsabilidad",
    body: [
      "Metal Concrete facilita publicación y gestión, pero no actúa como intermediario legal de compraventas inmobiliarias.",
      "Cada usuario es responsable de validar documentos, titularidad, estatus legal de inmuebles y condiciones de cierre.",
      "SUIVOS no será responsable por daños indirectos, lucro cesante o controversias derivadas de acuerdos entre usuarios.",
    ],
  },
  {
    title: "8. Modificaciones",
    body: [
      "SUIVOS puede actualizar estos términos para reflejar cambios legales, regulatorios, operativos o del producto.",
      "La versión publicada en esta página será la vigente al momento de su consulta y uso.",
    ],
  },
  {
    title: "9. Jurisdicción y ley aplicable",
    body: [
      "Estos términos se rigen por las leyes de los Estados Unidos Mexicanos.",
      "Para cualquier controversia, las partes se someten a los tribunales competentes de Monterrey, Nuevo León, renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o futuro.",
    ],
  },
];

const Terms = () => {
  return (
    <div className="min-h-screen bg-muted/20">
      <Header />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 md:py-14">
        <section className="rounded-2xl border border-border bg-background p-6 sm:p-8 md:p-10 shadow-sm">
          <p className="text-xs uppercase tracking-[0.18em] text-primary font-semibold mb-3">
            Legal
          </p>
          <h1
            className="text-3xl sm:text-4xl font-bold text-foreground"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            Términos y Condiciones
          </h1>
          <p className="text-sm sm:text-base text-muted-foreground mt-4 max-w-3xl">
            Estos términos regulan el uso de Metal Concrete, operada por SUIVOS,
            S.A. de C.V., y establecen las responsabilidades de todos los
            usuarios y participantes dentro de la plataforma.
          </p>

          <div className="mt-8 space-y-4 sm:space-y-5">
            {sections.map((section) => (
              <article
                key={section.title}
                className="rounded-xl border border-border bg-muted/30 p-4 sm:p-5"
              >
                <h2 className="text-base sm:text-lg font-semibold text-foreground">
                  {section.title}
                </h2>
                <div className="mt-2 space-y-2 text-sm sm:text-[15px] text-muted-foreground leading-relaxed">
                  {section.body.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>

          <section className="mt-6 rounded-xl border border-border bg-background p-4 sm:p-5">
            <h2 className="text-base sm:text-lg font-semibold text-foreground">
              10. Contacto legal
            </h2>
            <p className="mt-2 text-sm sm:text-[15px] text-muted-foreground leading-relaxed">
              Responsable: SUIVOS, S.A. de C.V. Para dudas legales, de
              cumplimiento o solicitudes relacionadas con estos términos, puedes
              escribirnos a{" "}
              <a
                href="mailto:soporte@metalconcrete.com"
                className="text-primary hover:underline"
              >
                soporte@metalconcrete.com
              </a>
              .
            </p>
          </section>

          <p className="text-xs text-muted-foreground mt-8 pt-5 border-t border-border">
            Última actualización: 26 de abril de 2026
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Terms;
